<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
			<template v-for="(item, i) in statistics">
				<v-flex :key="i" xs12 md4>
					<v-card outlined color="accent" dark>
						<v-card-title primary-title class="py-1">
							{{ item.title }}
							<v-spacer></v-spacer>
							<v-icon>{{ item.icon }}</v-icon>
						</v-card-title>
						<v-card-actions class="py-2 px-2">
							<v-spacer></v-spacer>
							<span class="display-1">{{ item.count }}</span>
							<v-spacer></v-spacer
						></v-card-actions>
					</v-card>
				</v-flex>
			</template>
		</v-layout>
	</v-container>
</template>
<script>
export default {
	props: ["restaurant_count", "outlet_count", "location_count"],
	data() {
		return {
			statistics: [
				{
					title: "Locations",
					icon: "mdi-map-marker",
					count: this.location_count,
				},
				{
					title: "Restaurants",
					icon: "mdi-home-city-outline",
					count: this.restaurant_count,
				},
				{
					title: "Outlets",
					icon: "mdi-home-variant-outline",
					count: this.outlet_count,
				},
			],
		};
	},
};
</script>